import React from 'react';
import { pricing } from '../lib/pricing';
const plans = [{
  name: 'Monthly',
  price: pricing.monthlyPrice,
  period: pricing.monthlyPeriod,
  billing: pricing.monthlyBilling,
  equivalent: pricing.monthlyWeeklyEquivalent
}, {
  name: 'Yearly',
  price: pricing.annualPrice,
  period: pricing.annualPeriod,
  billing: pricing.annualBilling,
  equivalent: pricing.annualWeeklyEquivalent
}];
export function PricingBlock() {
  return <div data-id="element-291" data-mp="3ligqz5acloej">
      <div className="grid gap-5 md:grid-cols-2" data-id="element-292" data-mp="3qexnonvm5b38">
        {plans.map(plan => <div key={plan.name} className="flex h-full flex-col rounded-3xl border-2 border-ink bg-white p-7 shadow-chunky md:p-8" data-id="element-293" data-mp="3qh1o2vuazryr">
            <h3 className="font-display text-[22px] text-ink" data-id="element-294" data-mp="3gow1y2qqg4rh">{plan.name}</h3>
            <p className="mt-4 flex flex-wrap items-baseline gap-x-2" data-id="element-295" data-mp="89m271abfbmv">
              <span className="font-display text-[48px] leading-none tracking-tight text-ink md:text-[56px]" data-id="element-296" data-mp="87hmzn6yuq7a">
                {plan.price}
              </span>
              <span className="text-[18px] font-semibold text-ink-soft" data-id="element-297" data-mp="2esbfcn6igfbo">{plan.period}</span>
            </p>
            <p className="mt-4 text-[17px] text-ink-soft" data-id="element-298" data-mp="29t8cn9e06l6v">{plan.billing}</p>
            <p className="mt-2 text-[15px] text-ink-soft" data-id="element-299" data-mp="2ohla6asqoc3h">
              About {plan.equivalent} a week, for comparison only. Not billed weekly.
            </p>
            <p className="mt-auto border-t-2 border-ink/10 pt-4 text-[16px] text-ink" data-id="element-300" data-mp="2joa1030gfj8e">
              Every world, all {pricing.lessonCount} adventures, up to {pricing.maxProfiles} child profiles.
            </p>
          </div>)}
      </div>

      <div className="mt-6 rounded-3xl bg-white/70 p-6 md:p-7" data-id="element-301" data-mp="37g76lcdb9f12">
        <p className="text-[17px] font-bold text-ink" data-id="element-302" data-mp="32gumgzdtqm26">{pricing.billingTerms}</p>
        <p className="mt-2 text-[17px] text-ink-soft" data-id="element-303" data-mp="32ermpnmvdek9">{pricing.checkoutNote}</p>
      </div>
    </div>;
}